import { Controller } from "@hotwired/stimulus"

// Focuses the name field when the Save view menu opens. dropdown_controller owns
// open/close; this only moves focus after that toggle has shown the field.
export default class extends Controller {
  static targets = ["name"]

  focusName() {
    requestAnimationFrame(() => {
      const menu = this.element.querySelector("[data-dropdown-target='menu']")
      if (!menu || menu.hidden || !this.hasNameTarget) return

      this.nameTarget.focus()
      this.nameTarget.select()
    })
  }
}
